import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import zh from './locales/zh.json';
import en from './locales/en.json';

// 配置i18n
// 在初始化前，先尝试从 localStorage 读取语言设置
const getInitialLanguage = (): string => {
  try {
    const storedLang = localStorage.getItem('i18nextLng');
    if (storedLang) {
      return storedLang.split('-')[0]; // 处理地区代码，如 'en-US' -> 'en'
    }
  } catch (e) {
    console.warn('Failed to read language from localStorage:', e);
  }
  return 'zh'; // 默认中文
};

i18n
  .use(LanguageDetector) // 自动检测用户语言
  .use(initReactI18next) // 绑定react-i18next
  .init({
    resources: {
      zh: {
        translation: zh
      },
      en: {
        translation: en
      }
    },
    fallbackLng: 'zh', // 默认语言为中文
    lng: getInitialLanguage(), // 从 localStorage 读取初始语言
    debug: false,
    interpolation: {
      escapeValue: false // React已经做了XSS防护
    },
    detection: {
      // 语言检测选项
      order: ['localStorage', 'navigator'], // 优先从localStorage读取，其次是浏览器语言
      caches: ['localStorage'], // 缓存到localStorage
      lookupLocalStorage: 'i18nextLng', // localStorage的key名
    }
  });

export default i18n;


